import { IntegrationV2ResponseSchema } from "@redotech/internal-ctx-client";
import * as z from "zod/v4";

export const publishContextualIntegration = {
  name: "publishContextualIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: IntegrationV2ResponseSchema,
};
